import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";

export enum ViewportScreenSize {
	SMALL = "small",
	MEDIUM = "medium",
	LARGE = "large",
	DESKTOP = "desktop",
}

type ViewportState = {
	screenSize: ViewportScreenSize;
};

const initialState: ViewportState = {
	screenSize: ViewportScreenSize.DESKTOP,
};

export const ViewportStore = signalStore(
	{ providedIn: "root" },
	withState(initialState),
	withMethods((store) => ({
		setScreenSize: (screenSize: ViewportScreenSize): void => {
			patchState(store, () => ({
				screenSize: screenSize,
			}));
		},
		isMediumOrSmallerScreen: (): boolean => {
			return [ViewportScreenSize.SMALL, ViewportScreenSize.MEDIUM].includes(store.screenSize());
		},
		isLargeOrSmallerScreen: (): boolean => {
			return [
				ViewportScreenSize.SMALL,
				ViewportScreenSize.MEDIUM,
				ViewportScreenSize.LARGE
			].includes(store.screenSize());
		},
	}))
);
